import getTransmissions from '../../api/shop/getTransmissions';
import SelectWithFetch from './SelectWithFetch';

const SelectCarTransmissions = (props) => {
  return <SelectWithFetch fetch={getTransmissions} label="Ð¢Ð¸Ð¿ ÐºÐ¾ÑÐ¾Ð±ÐºÐ¸ Ð¿ÐµÑÐµÐ´Ð°Ñ" placeholder="Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÑÐ¸Ð¿" {...props} />;
};

export default SelectCarTransmissions;
